export type FeatureKey =
	| "transcripts"
	| "analytics"
	| "workforce"
	| "queries"
	| "peopleSearch"
	| "lists"
	| "kanban"
	| "tasks"
	| "calendar"
	| "roles"
	| "help"
	| "duplicateFinder"
	| "aiTopMatches"
	| "aiChat";

export interface FeatureFlagDefinition {
	label: string;
	description: string;
	defaultEnabled: boolean;
}

export const FEATURE_FLAGS: Record<FeatureKey, FeatureFlagDefinition> = {
	transcripts: {
		label: "Meeting transcripts",
		description: "Microsoft Teams transcript sync, transcripts page, candidate transcripts tab.",
		defaultEnabled: false,
	},
	analytics: {
		label: "Analytics",
		description: "Analytics dashboard and reports.",
		defaultEnabled: true,
	},
	workforce: {
		label: "Workforce",
		description: "Workforce module (bench, workforce entities and detail pages).",
		defaultEnabled: true,
	},
	queries: {
		label: "Queries",
		description: "Saved queries and advanced search.",
		defaultEnabled: true,
	},
	peopleSearch: {
		label: "People Search",
		description: "Advanced faceted People Search page (three-pane filters, criteria and results).",
		defaultEnabled: true,
	},
	lists: {
		label: "Lists",
		description: "Custom lists of entities.",
		defaultEnabled: true,
	},
	kanban: {
		label: "Kanban",
		description: "Kanban board view.",
		defaultEnabled: true,
	},
	tasks: {
		label: "Tasks",
		description: "Task management module.",
		defaultEnabled: true,
	},
	calendar: {
		label: "Calendar",
		description: "Calendar page and event views.",
		defaultEnabled: true,
	},
	roles: {
		label: "Roles",
		description: "Roles entity page (not yet on this branch — pre-registered for main).",
		defaultEnabled: true,
	},
	help: {
		label: "Help",
		description: "In-app help page (not yet on this branch — pre-registered for main).",
		defaultEnabled: true,
	},
	duplicateFinder: {
		label: "Duplicate finder",
		description: "Candidate duplicate finder page (lists groups of potential duplicate candidates and merges them).",
		defaultEnabled: true,
	},
	aiTopMatches: {
		label: "AI Top 25",
		description: "Agentic AI pre-matching on the job kanban: screens every candidate of the organization and suggests a top 25 (replaces Advanced Search).",
		defaultEnabled: false,
	},
			aiChat: {
				label: "AI Chat",
				description: "Floating AI chat assistant available on every page.",
				defaultEnabled: false,
			},
		};

export const FEATURE_KEYS = Object.keys(FEATURE_FLAGS) as FeatureKey[];

export interface FeatureFlagRow {
	id: string;
	feature_key: string;
	organization_id: string | null;
	user_id: string | null;
	enabled: boolean;
	created_at: string;
	updated_at: string;
}
